import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistTraffic } from "../../Persist/TrafficPersister";
import * as trafficStages from "../../Stages/StagesTraffic";
import { stageMetaDataTraffic } from "../../Stages/StagesTraffic";
import * as trafficStatus from "../../LeadStatus/StatusTraffic";
import { paymentTypeSwitchDataTraffic } from "../PaymentTypeSwitchDataDefinitions/paymentTypeSwitchDataTraffic";
import trafficTransformations from "../FormTransformations/trafficTransformations";
import { stageFormDefinition as stageFormDefinitionTraffic } from "../FormDefinitions/traffic/stageFormDefinition";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionTraffic } from "../FormDefinitions/traffic/fullFormDefinition";
import { inquiryTypeAvailability } from "../../inquiryService";
import { ProductUnion } from "../../../types/ProductUnion";
import { Traffic } from "../../../types/Products/TrafficLaw/Traffic/Traffic";
import { getProductData } from "./productService";

export const traffic: ProductData<Traffic> = {
  urlPart: "verkehr",
  lbUrlPart: "ordnungswidrigkeit",
  label: translate("traffic.label"),
  generalLabel: translate("traffic.label"),
  apiUri: "traffic",
  persist: persistTraffic,
  stages: stageMetaDataTraffic,
  stageConstants: trafficStages,
  minimumCaseStatus: trafficStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: trafficStages.STAGE_INCOMPLETE,
  setBackCaseStage: trafficStages.STAGE_READY,
  paymentType: {
    backwards_insurance: "ARAG Verso",
    insurance: "RSV",
    private: "Selbstzahler",
  },
  paymentTypeSwitchData: paymentTypeSwitchDataTraffic,
  courtAppointmentCreationAvailable: (product: ProductUnion) => product.stage >= trafficStages.STAGE_AUTHORITY_ANSWERED,
  lbProductClass: "App\\Entity\\Legalbird\\TrafficLaw\\Traffic\\Traffic",
  formTransformations: trafficTransformations,
  formDefinition: () => stageFormDefinitionTraffic,
  formDefinitionExternals: () => formDefinitionExternals["traffic"],
  fullFormDefinition: ({ product }) => fullFormDefinitionTraffic(product),
  productSpecificDefinition: () => [],
  productCategory: "trafficLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.traffic,
};
